import { Button, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import { hasNonEmptyValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import * as oPath from 'Lib/Object/Path/Immutable';
import deepEquals from 'Lib/Object/deepEquals';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ILinkTestLink, LinkTestsDialog } from '../Core';
type DryMassOtherAssignedTestSectionProps = IWithWorksheetInjectedProps & {
  /**
   * Paths to the fields to get sibling tests
   */
  worksheetPath: string;
};
let DryMassOtherAssignedTestSection: React.FC<DryMassOtherAssignedTestSectionProps> = ({
  createWorksheetSelector,
  worksheetPath,
}) => {
  //Get all sibing worksheets
  const destinations = useSelector(
    (s) => oPath.get(s, `${worksheetPath}.syncModel.data.MoistureContentTestSiblings`),
    deepEquals
  );
  const sampleID = useSelector((s) => oPath.get(s, `${worksheetPath}.syncModel.header.Sample.SampleId`));
  //If no sibilings test, meaning is not TopLevel/Standalone Moisture Content Test
  const isTopLevelWorksheet = useSelector(
    pipe(
      (s) => oPath.get(s, `${worksheetPath}.syncModel.data.MoistureContentTestSiblings`),
      (r) => hasNonEmptyValue(r)
    )
  );
  const [shortTestNames, setShortTestNames] = useState('');
  const [TestLinks, SetTestLinks] = useState<ILinkTestLink[]>([]);
  useEffect(() => {
    let tempStr = '';
    destinations?.forEach(({ WorkSheetShortName }: any) => {
      tempStr += WorkSheetShortName + ', ';
    });
    //Trim trailing comma (",")
    const trimStr = tempStr.slice(0, tempStr.lastIndexOf(', '));
    setShortTestNames(trimStr);
  }, [destinations]);

  useEffect(() => {
    let testLinks: ILinkTestLink[] = [];
    destinations?.forEach(({ WorkSheetLongName, WorksheetUUID, Header, IsWorksheet }: any) => {
      let tempTestLink = {} as ILinkTestLink;
      tempTestLink.testName = WorkSheetLongName;
      tempTestLink.testUUID = WorksheetUUID;
      tempTestLink.testStatusHeader = Header;
      tempTestLink.isWorksheet = IsWorksheet;
      testLinks.push(tempTestLink);
    });
    SetTestLinks(testLinks);
  }, [destinations]);
  return (
    <>
      {isTopLevelWorksheet ? (
        <LinkTestsDialog messageTitle={`Tests on ${sampleID}`} siblingTests={TestLinks} alwaysEnabled>
          <Button subtle noPadding alwaysEnabled>
            <Field
              input={<TextOutput />}
              value={isTopLevelWorksheet ? `{${destinations.length}} ${shortTestNames}` : '-'}
              truncate
              fieldAdditionalClassName="DryMassOtherAssignedTestSection"
            />
          </Button>
        </LinkTestsDialog>
      ) : (
        <>-</>
      )}
    </>
  );
};

DryMassOtherAssignedTestSection = withInjectedProps(DryMassOtherAssignedTestSection);

export { DryMassOtherAssignedTestSection };
export default DryMassOtherAssignedTestSection;
